import { logOut } from 'Api/Login';

const useLogOut = () => {
  const logOutApi = async () => {
    const { transactionStatus } = await logOut();

    if (transactionStatus) window.location.reload();

    return transactionStatus;
  };

  return { logOutApi };
};

export default useLogOut;
